import { Avatar, Box, Button, Card, Grid, Icon, InputAdornment, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import UsersCard from './UsersCard';

function ListaUsuarios({ hostUser }) {
  const [searchUser, setSearchUser] = useState('');
  const { userList } = useSelector((state) => state.dagpacket);

  const userListFilt = userList.filter((user) => user.id !== hostUser.id);
  const userListNoHosted = userListFilt.filter(
    (user) => user?.hostUser === null || user.hostUser === undefined || user.hostUser === user.id
  );

  const filteredUsers = userListNoHosted?.filter((user) => {
    if (searchUser === '') {
      return user;
    }
    if (user?.displayName.toLowerCase().includes(searchUser.toLowerCase())) {
      return user;
    }
    return false;
  });

  console.log(userList);
  return (
    <Card sx={{ padding: '15px', marginTop: '15px' }}>
      <Typography variant="subtitle1">Lista de usuarios</Typography>
      <TextField
        sx={{ marginTop: '15px' }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon fontSize="25px" icon="eva:search-fill" />
            </InputAdornment>
          )
        }}
        label="Buscar usuario"
        variant="outlined"
        value={searchUser}
        onChange={(e) => setSearchUser(e.target.value)}
      />
      <Grid container spacing={1}>
        {searchUser && filteredUsers?.map((user) => <UsersCard key={user.id} dataUser={user} hostUser={hostUser} />)}
      </Grid>
    </Card>
  );
}

export default ListaUsuarios;
